import NavbarSearchSection from "./NavbarSearchSection";
import DesktopNavIcons from "./DesktopNavIcons";
import MoreToolsDropdown from "./MoreToolsDropdown";
import NavbarProfileActions from "./NavbarProfileActions";
import NotificationsMenu from "./NotificationsMenu";
import useNavbarActions from "./useNavbarActions";
import useMoreToolsMenu from "./useMoreToolsMenu";
import { useTopBarCounters } from "modules/topbar/api";

const Navbar = ({
  isDark,
  setIsOpen,
  handleChangePosition,
  navPosition,
  sidebar,
}) => {
  const { handelLogout, changeLng, handleSettings } =
    useNavbarActions(setIsOpen);

  const { moreMenuOpen, setMoreMenuOpen, moreMenuRef, moreMenuItems } =
    useMoreToolsMenu({ changeLng, handleSettings });

  const { data: counters, refetch: refetchCounters } = useTopBarCounters();

  return (
    <nav
      className={`px-3 sm:px-[25px] gap-2 sm:gap-4 lg:px-[41.5px] h-16 sm:h-20 flex justify-between items-center top-0 w-full z-[60] relative ${
        isDark ? "bg-chrome" : "bg-surface border-b border-border-light"
      }`}
    >
      <NavbarSearchSection
        isDark={isDark}
        sidebar={sidebar}
        navPosition={navPosition}
        handleChangePosition={handleChangePosition}
      />
      <div className="flex items-center gap-1.5 sm:gap-2 lg:gap-3 xl:gap-4 shrink-0 ms-auto sm:ms-0">
        <DesktopNavIcons
          isDark={isDark}
          changeLng={changeLng}
          handleSettings={handleSettings}
        />
        <div className="flex lg:hidden items-center gap-1.5">
          <NotificationsMenu
            isDark={isDark}
            count={counters?.notifications || 0}
            onChanged={refetchCounters}
          />
        </div>
        <MoreToolsDropdown
          isDark={isDark}
          moreMenuOpen={moreMenuOpen}
          setMoreMenuOpen={setMoreMenuOpen}
          moreMenuRef={moreMenuRef}
          moreMenuItems={moreMenuItems}
          changeLng={changeLng}
          handleSettings={handleSettings}
          handelLogout={handelLogout}
        />
        <NavbarProfileActions isDark={isDark} handelLogout={handelLogout} />
      </div>
    </nav>
  );
};

export default Navbar;
